// <purpose>The STATED rule behind the „Kürzel vorgeschlagen" chip (R34.4): first letters of the
// compound parts, at most three, uppercased; a single word gives its first two letters. It is a
// SUGGESTION the admin confirms or edits, never a silent derivation — German initialisms are
// conventions („LAS" for lastgang_bilanzierung), not a function of the word.</purpose>
// <dependencies>None — pure string function, called from OverlayRows.tsx on every label
// keystroke.</dependencies>
// <constraints>ABBR_PATTERN admits ÄÖÜäöü alongside ASCII letters/digits (pre-flight ruling,
// 2026-09-24): the server uppercases and admits umlauts too (core AbbrPattern
// `^[A-Z0-9ÄÖÜ]{1,3}$`), so a suggestion like „Ärger" → „ÄR" must be a pattern the client itself
// accepts before it ever reaches the network — a suggestion the client would refuse is a broken
// promise.</constraints>
export function suggestAbbr(label: string): string {
  const parts = label
    .replace(/([a-zäöüß])([A-ZÄÖÜ])/g, '$1 $2')   // internal capital = a part boundary
    .split(/[\s\-/_]+/)
    // Strip anything that is not a letter or digit — final review, minor: a part like "(intern)"
    // or "&" must not contribute a punctuation character as its own "initial". Unicode-aware
    // (\p{L}/\p{N}) so an umlaut-leading part still counts as one letter, not zero.
    .map(p => p.replace(/[^\p{L}\p{N}]/gu, ''))
    .filter(p => p.length > 0);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0].slice(0, 2).toLocaleUpperCase('de-DE');
  return parts.slice(0, 3).map(p => p.charAt(0)).join('').toLocaleUpperCase('de-DE');
}

// Receiver-side guard before a POST /manage/vocabulary — admits ASCII letters/digits AND ÄÖÜäöü
// (the server trims + uppercases, and its own pattern admits the same umlaut set; see
// <constraints> above). A draft that fails this never leaves the client.
export const ABBR_PATTERN = /^[A-Za-z0-9ÄÖÜäöü]{1,3}$/;
